import { render, staticRenderFns } from "./IconShoppingBagSolid.vue?vue&type=template&id=48f76cfa"
import script from "./IconShoppingBagSolid.vue?vue&type=script&lang=js"
export * from "./IconShoppingBagSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports